import { render } from "./Vacuna_VacunaMarc.vue?vue&type=template&id=2c96443a"
import script from "./Vacuna_VacunaMarc.vue?vue&type=script&lang=js"
export * from "./Vacuna_VacunaMarc.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__